import { createContext } from 'react';
import { DefaultTabKey } from 'console/shared/content/tab/types';
const default_value = {
    devices_rfs: [],
    devices_ids: [],
    dashboard_ui_settings: {},
    setDevicesRfs: () => { },
    sorting_mode: false,
    onSaveDashboardSettings: () => { },
    is_dashboard_ui_settings_changed: false,
};
export const DashboardContent = createContext(default_value);
const default_device_value = {
    tab_key: DefaultTabKey.heat_tab,
    setTabKey: () => { },
};
export const DashboardDeviceContent = createContext(default_device_value);
